import { APP_ROUTES } from "../constants";
import { PhoneNumberPage } from "../pages/PhoneNumberPage";
import { LoadingPage } from "../pages/LoadingPage";
import { LandingPage } from "../pages/LandingPage";
import { WelcomePage } from "../pages/WelcomePage";
import { LegalPage } from "../pages/LegalPage";
import { TermDetailPage } from "../pages/TermDetailPage";
import { CashDepositLandingPage } from "../pages/CashDepositLandingPage";
import { StoresMapPage } from "../pages/StoresMapPage";
import { HowToPayInCashPage } from "../pages/HowToPayInCashPage";
import { StoresPage } from "../pages/StoresPage";
import { CashStoresPage } from "../pages/CashStoresPage";
import { PaymentVerificationPage } from "../pages/PaymentVerificationPage";
import { DepositOnTheWayPage } from "../pages/DepositOnTheWayPage";
import { CipReviewPage } from "../pages/CipReviewPage";
import { SupportPage } from "../pages/SupportPage";
import { ErrorPage } from "../shared/error/pages/ErrorPage";
import { SessionExpiredPage } from "../shared/error/pages/SessionExpiredPage";
import { ServiceUnavailablePage } from "../shared/error/pages/ServiceUnavailablePage";
import { MaintenancePage } from "../shared/error/pages/MaintenancePage";

export type amountFormatterProps = (
  amount: number,
  currency?: string,
  numberFormatOptions?: {
    country?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  }
) => string;

export const amountFormatter: amountFormatterProps = (
  amount,
  currency = "USD",
  {
    country = "en-US",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = {}
) =>
  new Intl.NumberFormat(country, {
    style: "decimal",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);

/** Hero typography: en-US `25.00` split; `$` + ISO for USD, ISO suffix otherwise. */
export function formatHeroAmount(amount: number, currency: string) {
  const formatted = amountFormatter(amount, currency, {
    country: "en-US",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const [intPart, decPart = "00"] = formatted.split(".");
  const code = currency.toUpperCase();
  return {
    prefix: code === "USD" ? "$" : "",
    suffix: ` ${code}`,
    intPart,
    decPart,
  };
}

export interface IAppRoutes {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: any;
}

export const routesList: IAppRoutes[] = [
  { path: APP_ROUTES.PHONE_PAGE, Component: PhoneNumberPage },
  // Magic-link entry: the flow is encoded in the linkId itself
  { path: APP_ROUTES.LOADING_PAGE, Component: LoadingPage },
  { path: "/:linkId", Component: LoadingPage },
  { path: APP_ROUTES.LANDING_PAGE, Component: LandingPage },
  { path: APP_ROUTES.WELCOME_PAGE, Component: WelcomePage },
  { path: APP_ROUTES.LEGAL_PAGE, Component: LegalPage },
  { path: APP_ROUTES.TERM_DETAIL_PAGE, Component: TermDetailPage },
  // Cash-deposit flow
  {
    path: APP_ROUTES.CASH_DEPOSIT_LANDING_PAGE,
    Component: CashDepositLandingPage,
  },
  { path: APP_ROUTES.STORES_MAP_PAGE, Component: StoresMapPage },
  { path: APP_ROUTES.HOW_TO_PAY_IN_CASH_PAGE, Component: HowToPayInCashPage },
  { path: APP_ROUTES.STORES_PAGE, Component: StoresPage },
  { path: APP_ROUTES.CASH_STORES_PAGE, Component: CashStoresPage },
  {
    path: APP_ROUTES.PAYMENT_VERIFICATION_PAGE,
    Component: PaymentVerificationPage,
  },
  { path: APP_ROUTES.DEPOSIT_ON_THE_WAY_PAGE, Component: DepositOnTheWayPage },
  { path: APP_ROUTES.CIP_REVIEW_PAGE, Component: CipReviewPage },
  { path: APP_ROUTES.SUPPORT_PAGE, Component: SupportPage },
  { path: APP_ROUTES.ERROR_PAGE, Component: ErrorPage },
  { path: APP_ROUTES.SESSION_EXPIRED_PAGE, Component: SessionExpiredPage },
  {
    path: APP_ROUTES.SERVICE_UNAVAILABLE_PAGE,
    Component: ServiceUnavailablePage,
  },
  {
    path: APP_ROUTES.MAINTENANCE_PAGE,
    Component: MaintenancePage,
  },
];
